import { useCallback, useState } from "react";
import { LOCAL_STORAGE_KEY } from "../models/local-storage-keys";

export const useLocalStorageState = <T>(
  localStorageKey: LOCAL_STORAGE_KEY,
  initialValue: T | null = null,
): [T, (value: T) => void] => {
  const [value, setValue] = useState<T>(
    localStorage.getItem(localStorageKey) === null || sessionStorage.getItem(localStorageKey) === undefined
      ? initialValue
      : JSON.parse(localStorage.getItem(localStorageKey) || ""),
  );

  const onChangeValue = useCallback(
    (_value: T) => {
      setValue(_value);
      localStorage.setItem(localStorageKey, JSON.stringify(_value));
    },
    [setValue, localStorageKey],
  );

  return [value, onChangeValue];
};
